const ASYNC_STATUS = {
    awaiting: 1,
    running: 2,
    finished: 3,
    error: 4,
};
export default ASYNC_STATUS;
